import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryBrowse() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            电影分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            按类型探索韩国电影，发现不同风格的光影魅力
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-5 md:p-6 border border-background-300/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <div className="flex items-center gap-1 mt-4 text-xs text-primary-500 font-medium">
                <span>浏览电影</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}